// AUTO-GENERATED — DO NOT EDIT BY HAND.
// Source of truth: aol_schemas.ws_events (aol-us-shared). Regenerate with
// `./devops build types` (emitter: aol_schemas/export_ws.py).

export const HandoffDomain = {
  BILLING: 'billing',
  TECHNICAL: 'technical',
  ACCOUNT: 'account',
  GENERAL: 'general',
} as const;
export type HandoffDomain = (typeof HandoffDomain)[keyof typeof HandoffDomain];

export const HandoffEndReason = {
  AGENT_RESOLVED: 'agent_resolved',
  USER_ENDED: 'user_ended',
  TIMEOUT_NO_AGENT: 'timeout_no_agent',
  ERROR: 'error',
} as const;
export type HandoffEndReason = (typeof HandoffEndReason)[keyof typeof HandoffEndReason];

export const WSHandoffEventType = {
  HANDOFF_STARTED: 'handoff_started',
  AGENT_JOINED: 'agent_joined',
  AGENT_MESSAGE: 'agent_message',
  HANDOFF_ENDED: 'handoff_ended',
  HANDOFF_TIMEOUT: 'handoff_timeout',
  CONTACT_INFO_REQUESTED: 'contact_info_requested',
  CONTACT_SUMMARY: 'contact_summary',
  AGENT_TEXT: 'agent_text',
  END_HANDOFF: 'end_handoff',
  CONTACT_INFO: 'contact_info',
} as const;
export type WSHandoffEventType = (typeof WSHandoffEventType)[keyof typeof WSHandoffEventType];

export const WSEventTag = {
  MESSAGE_PERSISTED: 'message_persisted',
  TOOL_TIMEOUT_OFFER: 'tool_timeout_offer',
  RETRY_TOOL_CALL: 'retry_tool_call',
  TOOL_RETRY_OUTCOME: 'tool_retry_outcome',
  RTC_CALL: 'rtc_call',
  RTC_CALL_ACK: 'rtc_call_ack',
  RTC_CALL_ANSWER: 'rtc_call_answer',
  RTC_CALL_FAILED: 'rtc_call_failed',
  RTC_HANGUP: 'rtc_hangup',
  RTC_CALL_CANCEL: 'rtc_call_cancel',
  PAGE_CONTEXT: 'page_context',
  PAGE_CONTEXT_ACK: 'page_context_ack',
} as const;
export type WSEventTag = (typeof WSEventTag)[keyof typeof WSEventTag];

export const ToolRetryResult = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  ABANDONED: 'abandoned',
  REJECTED: 'rejected',
} as const;
export type ToolRetryResult = (typeof ToolRetryResult)[keyof typeof ToolRetryResult];

export const RtcCallFailureReason = {
  UPSTREAM_ERROR: 'upstream_error',
  ATTACH_FAILED: 'attach_failed',
} as const;
export type RtcCallFailureReason = (typeof RtcCallFailureReason)[keyof typeof RtcCallFailureReason];
